import {
  CurrentPositionMarker,
  EndPointMarker,
  StartPointMarker,
  WaypointMarker,
} from "./Markers";
import { PathMarkersProps } from "./types";

export const PathMarkers = ({
  planPoints,
  currentFrameIndex,
  onSelectedFrameIndexChange,
}: PathMarkersProps) => {
  const len = planPoints.length;

  if (!len) return null;

  const last = len - 1;

  // Guard against out-of-range index
  const safeIndex = Math.min(Math.max(currentFrameIndex, 0), last);
  const currentPoint = planPoints[safeIndex];

  const start = planPoints[0];
  const end = planPoints[last];

  return (
    <>
      {planPoints.map((p, i) => {
        if (i === 0 || i === last) return null;
        if (i === safeIndex) return null;

        return (
          <WaypointMarker
            key={`wp-${i}`}
            point={{ x: p.x, y: p.y }}
            frameIndex={i}
            frameName={p.frameName}
            onSelectedFrameIndexChange={onSelectedFrameIndexChange}
          />
        );
      })}
      {safeIndex !== 0 && (
        <StartPointMarker
          key="start"
          point={{ x: start.x, y: start.y }}
          frameName={start.frameName}
          onSelectedFrameIndexChange={onSelectedFrameIndexChange}
        />
      )}
      {len > 1 && safeIndex !== last && (
        <EndPointMarker
          key="end"
          point={{ x: end.x, y: end.y }}
          frameName={end.frameName}
          endFrameIndex={last}
          onSelectedFrameIndexChange={onSelectedFrameIndexChange}
        />
      )}
      {currentPoint && (
        <CurrentPositionMarker
          key="current"
          point={{ x: currentPoint.x, y: currentPoint.y }}
        />
      )}
    </>
  );
};
